import { render } from "./purchase-returns-modal.vue?vue&type=template&id=1b897913"
import script from "./purchase-returns-modal.vue?vue&type=script&lang=js"
export * from "./purchase-returns-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__